import { LoadingSkeletonCircle } from "shared/components/molecules/LoadingSkeleton/atoms/LoadingSkeletonCircle";
import { LoadingSkeletonSquare } from "shared/components/molecules/LoadingSkeleton/atoms/LoadingSkeletonSquare";
import { LoadingSkeletonText } from "shared/components/molecules/LoadingSkeleton/atoms/LoadingSkeletonText";

export const LoadingSkeleton = {
  Text: LoadingSkeletonText,
  Circle: LoadingSkeletonCircle,
  Square: LoadingSkeletonSquare,
};
